angular.module('app').service('tagService', function($http, $q) {
    "ngInject";

    var self = this;
    self.allTags = [];

    self.load = function() {
        return $http.get('/api/v1/admin/school_tag?results_per_page=500').then(function(response) {
            self.allTags = response.data.objects || [];
            return self.allTags;
        });
    };

    self.search = function(text) {
        var q = (text || '').toLowerCase().trim();
        if (!q) return self.allTags;
        return self.allTags.filter(function(t) {
            return t.name.toLowerCase().indexOf(q) !== -1;
        });
    };

    self.transformChip = function($chip) {
        if (angular.isObject($chip)) return $chip;
        var name = ($chip || '').trim();
        if (!name) return null;
        var existing = self.allTags.find(function(t) {
            return t.name.toLowerCase() === name.toLowerCase();
        });
        if (existing) return existing;
        return {name: name};
    };

    self.ensurePersisted = function(tags) {
        var promises = tags.map(function(tag, idx) {
            if (tag && tag.id) return $q.when(tag);
            return $http.post('/api/v1/admin/school_tag', {name: tag.name}).then(function(response) {
                var saved = response.data;
                tags[idx] = saved;
                if (!self.allTags.find(function(t) { return t.id === saved.id; })) {
                    self.allTags.push(saved);
                }
                return saved;
            });
        });
        return $q.all(promises);
    };
});
